<template>
  <div class="common-footer" :style="{'max-width': width}">
    <p class="footer__title">(주)홈핏</p>
    <div class="footer__content">
      <div class="footer__row footer__row__all">
        <p class="footer__row__text">
          <span>대표 : 엄선진</span
          ><span>서울특별시 영등포구 당산로49길 3 메트로29, 8층</span
          ><span>사업자등록번호 : 617-86-27572</span>
        </p>
        <p class="footer__row__text">
          <span>통신판매신고번호 :제 2025-서울영등포-1999호</span
          ><span>고객센터 문의 : 02-6958-8253</span>
        </p>
        <p class="footer__row__text">
          <span>전문가지원 문의 : <a href='https://homefit.channel.io/support-bots/99613' style='text-decoration: underline;color:#555;font-weight: 300;' target='_blank'>채널톡</a></span
          ><span>제휴 문의 : marketing@homefit.co.kr</span
          ><span>E-mail : help@homefit.co.kr</span>
        </p>
      </div>
      <div class="footer__row">
        <p class="footer__row__text footer__row__text--medium">
          <span class="cursor" @click="moveToTerms('/docs/platform_usage/')"
            >이용약관</span
          ><span class="cursor" @click="moveToTerms('/docs/privacy/')"
            >개인정보취급방침</span
          ><span
            class="cursor"
            @click="
              moveToTerms(
                'http://www.ftc.go.kr/bizCommPop.do?wrkr_no=6178627572'
              )
            "
            >사업자정보확인</span
          >
        </p>
      </div>
      <div class="footer__row">
        <p class="footer__row__text">
          <span>2025 HOMEFIT Inc. All rights reserved.</span>
        </p>
      </div>
      <div class="footer__row mt30">
        <p class="footer__row__icon">
          <a href="https://blog.naver.com/homefit_coach" target="_blank"
            ><img
              src="https://dcse8twossp9.cloudfront.net/static/img/v2/icon/naver.svg"
              alt
          /></a>
          <a href="https://www.instagram.com/homefit_official" target="_blank"
            ><img
              src="https://dcse8twossp9.cloudfront.net/static/img/v2/icon/insta.svg"
              alt
          /></a>
          <a
            href="https://www.youtube.com/channel/UCKWaoLU3rNVerZrm1pL2mvw"
            target="_blank"
            ><img
              src="https://dcse8twossp9.cloudfront.net/static/img/v2/icon/youtube.svg"
              alt
          /></a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonFooterV2',
  props:{
    width: {type: String, default: '904px'},
  },
  methods: {
    moveToTerms(url) {
      location.href = url
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/_index.scss';
.common-footer {
  max-width: 904px;
  margin: 0 auto;
  padding: 48px 24px;
}
.footer__title {
  font-weight: $medium;
  font-size: 15px;
  line-height: 20px;
  color: #555555;
  margin-bottom: 24px;
}
.footer__content {
  display: flex;
  flex-direction: column;
}
.footer__row + .footer__row {
  margin-top: 24px;
}
.footer__row + .footer__row.mt30 {
  margin-top: 30px;
}
.footer__row__text {
  span {
    font-size: 12px;
    line-height: 20px;
    color: #555555;
    font-weight: $light;
    &.cursor {
      cursor: pointer;
    }
    & + span::before {
      content: 'I';
      font-size: 12px;
      margin: 0 12px;
    }
  }
  &.footer__row__text--medium {
    span {
      font-weight: $medium;
    }
  }
}
.footer__row__icon {
  display: flex;
  gap: 12px;
  img {
    width: 42px;
    height: 30px;
  }
}
@media all and (max-width: 648px) {
  .footer__row {
    &.footer__row__all {
      .footer__row__text {
        display: flex;
        flex-direction: column;
        span {
          & + span::before {
            display: none;
          }
        }
      }
    }
  }
}
</style>
